import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { resetALL } from "../../../../../../../.globals/redux/actions";
import { endpoints } from "../../../../../../../core/defaultValues";
import { clientQuery } from "../../../../../../../core/data/GraphQLApi";
import { ExceptionManager } from "../../../../../../../core/logManager";

const INIT_STATE = {
    driver: null,
    loading: false
};

const route = "modules/driverPerformance/views/events/modals/driverInfo/redux/slice";

export const getDriver = createAsyncThunk("driverPerformance/eventTab/getDriver", async (payload, { rejectWithValue }) => {
    const { id } = payload
    try {
        const response = await clientQuery(
            `
                query getDriver ($id: Int!) {
                    data: getDriver (id: $id) {
                        id
                        name
                        supervisor {
                            id
                            userName
                            firstName
                            lastName
                        }
                        tagIds
                    }
                }
            `,
            {
                id
            },
            endpoints.GRAPHQL_GENERAL_V2
        );

        return response?.data
    } catch (exc) {
        ExceptionManager(exc, route, "getCustomers");
        return rejectWithValue(exc);
    }
}
);

//Slice
const driverPerformanceEventsTabDriverInfoRedux = createSlice({
    name: "driverPerformance/assetInfo",
    initialState: INIT_STATE,
    reducers: {
        reset(state, action) {
            return action.payload ? { ...state, ...action.payload } : INIT_STATE;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(resetALL, () => INIT_STATE);

        //getDriver
        builder.addCase(getDriver.pending, (state, action) => {
            state.loading = true;
        });
        builder.addCase(getDriver.fulfilled, (state, action) => {
            state.loading = false;
            state.driver = action.payload
        });
        builder.addCase(getDriver.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });

    },
});

// Extract and export the action creators object and the reducer
export const { actions, reducer } = driverPerformanceEventsTabDriverInfoRedux;

// Extract and export each action creator by name
export const { reset } = actions;

// Export the reducer, either as a default or named export
export default reducer;
